import { ACTIONS, HTTP_METHODS, API_URL } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";
import AES from "UTILS/AES";
import querystring from 'querystring';

export class CustomerCoBrowseActionV2 extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
  }

  /**
   * 新アーキテクチャのAPIを叩く
   * @param {*} data
   * @since 2022-11-29
   */
  handleBookCoBrowseSessionV2(data) {
    // 新アーキテクチャのAPIを叩き、レスポンスを受信する
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: data,
        url: API_URL.APP_EMULATION_START_SESSION
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_STARTED
          });
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  /**
   * フォロワーが認否ダイアログで「許可」を押下した際にCallされる
   * @param {*} data { userName, sessionKey, uniqueId, customerId } ※customerId の値は未設定
   * @returns
   */
  joinFollowerSession(data) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: data,
        url: API_URL.APP_EMULATION_JOIN_SESSION
      }).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  handleBookCoBrowseSession(data) {
    let requestParams = querystring.stringify(data);
    if (window._env_.REACT_APP_ENABLE_AES_ENCRYPTION === "true") {
      const paramsStringify = JSON.stringify(data);
      const encodeParamsStringify = encodeURIComponent(paramsStringify);
      const encryptParamsStringify = AES.encryption(encodeParamsStringify);
      requestParams = querystring.stringify({ item: encryptParamsStringify });
    }
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: requestParams,
        url: window._env_.REACT_APP_ENABLE_AES_ENCRYPTION === "true" ?
          API_URL.CUSTOMER_CO_BROWSE :
          API_URL.CUSTOMER_CO_BROWSE_TEST,
        isCoBrowseRequest: true
      }).then(
        (response) => {
          this.dispatch({
            type: ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_DATA,
            roomId: response.data.roomId,
            shareUrl: response.data.shareUrl,
            layoutCode: data.layoutCode
          });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  updateCustomerCoBrowsePermissionReply(flag) {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_REPLY,
      value: flag
    });
  }

  updateParticipantCoBrowseStatus(uniqueId, flag) {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_PARTICIPANT_STATUS_UPDATE,
      value: flag,
      uniqueId
    });
  }

  showHideCustomerCoBrowse(flag) {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.SHOW_CUSTOMER_CO_BROWSE,
      value: flag
    });
  }

  endCustomerCoBrowse() {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_END_SESSION
    });
  }

  leaveCustomerCoBrowse = (uniqueId) => {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_LEAVE_SESSION,
      value: uniqueId
    });
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_PARTICIPANT_STATUS_UPDATE,
      uniqueId,
      value: false
    });
    if (this.getState().SessionReducer.uniqueId === uniqueId) {
      this.dispatch({
        type: ACTIONS.CUSTOMER_CO_BROWSE.SHOW_CUSTOMER_CO_BROWSE,
        value: false
      });
    }
  }

  getCobrowseTargetSites(sessionKey) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.GET_CO_BROWSE_SITES}`,
        requestBody: {
          sessionKey
        }
      }).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  showTargetSiteSelectionModalAction(flag) {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.SHOW_TARGET_SITE_SELECTION_MODAL,
      value: flag
    });
  }

  /**
   * exCloserサーバー側から取得した appEmulationUrl を確保しておく
   * @param {*} appEmulationUrl
   */
  setAppEmulationUrl(appEmulationUrl) {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.SET_APP_EMULATION_URL,
      value: appEmulationUrl
    });
  }

  /**
   * exCloserサーバー側から取得した appEmulationUrl を確保しておく(フォロワー用)
   * @param {*} appEmulationUrl
   */
  setAppEmulationUrlForFollower(appEmulationUrl) {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.SET_APP_EMULATION_URL_FOR_FOLLOWER,
      value: appEmulationUrl
    });
  }

  /**
   * layoutCode を確保しておく
   * @param {*} layoutCode
   */
  setLayoutCode(layoutCode) {
    this.dispatch({
      type: ACTIONS.CUSTOMER_CO_BROWSE.SET_LAYOUT_CODE,
      value: layoutCode
    });
  }
}

export default CustomerCoBrowseActionV2;
